<template lang="html">
<div>
   <v-header backTo="Login profissional">
        <router-link  :to="{name: 'client-login'}" class="linkLogin">
          Entrar
        </router-link>
    </v-header>
  <v-page class="page-indication" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">

    <div class="autoRegister">
    <v-login class="card-register">
      <div class="center">
          <div class="registerLeft">
            <div class="company">
              <p>C</p>
              <p>L</p>
              <p>I</p>
              <p>E</p>
              <p>N</p>
              <p>T</p>
              <p>E</p>
              <p>S</p>
            </div>
            <div>
              <img class="photo" :src="img_url">
            </div>
          </div>
      <div class="registerRight">

        <!-- <v-text tag="h2" class="h4 title center mb-3">Crie sua conta</v-text> -->
        <div class= "titleRegister">

           <span class="spanColor">   Indique </span> Clientes
          </div>

        <v-input type="text" id="signup-first-name" placeholder="Nome" class="inputRegister" v-model="name"/>

        <v-input type="text" id="signup-last-name" placeholder="Empresa" v-model="company"/>



        <v-input type="tel" id="signup-phone" placeholder="Celular/Whatsapp"  v-model="cel_phone"/>
          <v-input
        type="textarea"
        rows="5"
        v-model="teste"
        >Observação sobre a indicação</v-input
      >

        <small>

          </v-input>
        </small>
        <v-button
          class="block primary"
          @click="signup()"
          style="background-color: #0377AA; color:white"
          :disabled="!accepted_term"
          >Enviar</v-button
        >


      </div>
      </div>
    </v-login>
    </div>
  </v-page>
  </div>
</template>

<script>
import apiClient from '@/api/client';
// import apiVibbrante from '@/api/vibbrante'

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      name: '',
      company: '',

      email: '',

      cel_phone: '',
      img_url: require('../../assets/photoPeople/Lucas.png'),
      img_background_url: require('../../assets/background/fundoAzul.svg'),

      teste: '',
    };
  },
  methods: {
    signup() {
      if (this.profile === 'client') {
        apiClient
          .sign_up(
            this.email,
            this.password,
            this.confirm_password,
            this.name,
            this.lastname,
            this.accepted_term,
            this.cel_phone,
            this.position,
            this.area
          )
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('registerClient', response);
              this.$router.push({ name: 'client-register-success' });
            }
          })
          .catch((e) => {
            this.$children[0].showErrorMsg({ message: e });
          });
      } else {
        /* apiVibbrante.sign_up(this.email, this.password, this.confirm_password, this.name, this.nickname, this.accepted_term).then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('registerVibbrante', response)
            this.$router.replace('/vibbrant')
          }
        }).catch((e) => {
           this.$notify(e, 'error')
        }) */
      }
    },
  },
};
</script>

<style lang="scss">
.linkLogin {
  color: white;
}
.page {
  min-height: calc(100vh - 60px);
}
.page-indication {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .autoRegister {
    width: 75%;
  }
  .card-register {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    @include media-breakpoint-up(md) {
      width: 100%;
    }
    .center {
      display: flex;
      align-items: center;
      padding: 2rem 2rem 0 0;

      @include media-breakpoint-down(md) {
        padding: 2rem;
      }
    }
    .registerLeft {
      display: flex;
      align-items: flex-end;

      height: 100%;
      width: 60%;
      @include media-breakpoint-down(md) {
        display: none;
      }
    }

    .photo {
      display: block;
      height: 700px;
      margin-top: 6px;
    }
    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
    .registerRight {
      display: flex;
      width: 40%;
      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }
  }
  .titleRegister {
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 40px;

    @include media-breakpoint-down(md) {
      font-size: 30px;
    }
  }

  .spanColor {
    color: #0377aa;
  }

  .inputRegister {
    border-radius: 20px !important;
  }
  .profForgot {
    color: #0377aa;
  }

  .lastInfo {
    display: flex;
    gap: 1rem;
    margin-top: 20px;
  }

  .SelectRegister {
    .multiselect__placeholder {
      color: rgb(72, 72, 72) !important;
    }
  }
  footer.page-footer {
    margin-top: auto;
    color: white;
  }
  .registeHere {
    display: flex;
    color: #0377aa !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/indication.vue